import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../../hooks/useTranslation";
import { Chevron } from "../../Icons";
import style from "./index.module.css";

const BrandsList = ({ brands, isExpandable = true }: ComponentPropsType) => {
  const { locale } = useTranslation();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const isAllowdToExpand = useMemo(() => {
    return (
      isExpandable &&
      ((brands.length > 12 && window.innerWidth >= 992) ||
        (brands.length > 4 && window.innerWidth >= 576 && window.innerWidth < 992) ||
        (brands.length > 2 && window.innerWidth < 576))
    );
  }, [brands.length, isExpandable]);

  return (
    <div
      className={`${isAllowdToExpand ? style["all_brands--fixed"] : ""}${
        isExpanded ? ` ${style["all_brands--expanded"]}` : ""
      }`}
    >
      <div className="row">
        {brands.map((brand, index) => (
          <div key={index} className={`${style.brands_list__single} col-lg-2 col-sm-3 col-6`}>
            <Link to={brand.link} {...(brand.link === "#" ? { style: { pointerEvents: "none" } } : {})}>
              {brand.models && <span className={style.single_brand_number}>{brand.models}</span>}
              <img src={brand.image} alt="" />
              {brand.name}
            </Link>
          </div>
        ))}
      </div>
      {isAllowdToExpand && (
        <button className={style.brands_more} onClick={() => setIsExpanded((current) => !current)}>
          {locale(isExpanded ? "show_less" : "show_more")}
          <Chevron height="11" width="11" color="#959595" />
        </button>
      )}
    </div>
  );
};

export default BrandsList;

type ComponentPropsType = {
  brands: {
    link: string;
    image: string;
    name: string;
    models?: number;
  }[];
  isExpandable?: boolean;
};
